import { render, staticRenderFns } from "./DynamicFormField.vue?vue&type=template&id=bb41b066&"
import script from "./DynamicFormField.vue?vue&type=script&lang=js&"
export * from "./DynamicFormField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports